import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { Formik, Field, ErrorMessage, useFormik } from "formik";
import * as Yup from "yup";
import { Switch } from "@headlessui/react";
import _ from "lodash";
import { useQuery, gql, useMutation } from "@apollo/client";
// import { ToastContainer, toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import gqlPreAuth from "../../../../gql/preAuth";
import ItemCodesSearchNSelect from "../../../PreAuth/components/request/ItemCodesSearchNSelect";
import PrescriptionSearchNSelect from "./PrescriptionSearchNSelect";
import MultiSelectComponent from "../../../PreAuth/components/request/MultiSelect";
import {
  items as sites,
  dentalItems as oralItems,
} from "../../../PreAuth/components/request/BodySites";
import { Button, Divider, IconButton } from "@mui/material";
import priceList from "../../../../gql/priceList";
import { BiSearch, BiX } from "react-icons/bi";
import DentalTeethSelectModalItem from "./DentalTeethSelectModalItem";
import AppButton from "../../../../shared/AppButton";
import CustomFilterInput from "../../../../shared/CustomFilterInput";

// import {HiOutlineZoomIn} from '@heroicons/react/20/solid/s';
// HiAdjustments
// import {FontAwesomeIcon} from 'fa-font'

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    minWidth: "95%",
  },
};

let subtitle;

function AddItemModal({
  showAddItemModal,
  setShowAddItemModal,
  formData,
  setFormData,
  values: formikValues,
  setMainFormFieldValue,
  item,
  currentItemIndex,
  setCurrentItemIndex,
}) {
  const navigate = useNavigate();
  const currentDate = new Date();

  const [enabled, setEnabled] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [showTeethSelectModal, setShowTeethSelectModal] = useState(false);

  // const [standardCodes, setStandardCodes] = useState([
  //   { code: "1", description: "Medical Devices" },
  // ]);

  // const {
  //   loading: loadingCodes,
  //   error: errorCodes,
  //   data: codesData,
  //   refetch,
  // } = useQuery(gqlPreAuth.GET_CODES, {
  //   variables: { fileName: "" },
  // });

  // React.useEffect(() => {
  //   if (codesData) {
  //     setStandardCodes(codesData?.getItemsCodeDescription?.data);
  //   }
  // }, [codesData]);

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = "#f00";
  }

  const types = [
    { id: "medical-devices", name: "Medical Devices" },
    { id: "medication-codes", name: "Medication Codes" },
    { id: "transportation-srca", name: "Transportation SRCA" },
    { id: "imaging", name: "Imaging" },
    { id: "services", name: "Services" },
    { id: "laboratory", name: "Laboratory" },
    { id: "oral-health-op", name: "Oral Health OP" },
    { id: "procedures", name: "Procedures" },
  ];

  const dentalSubSites = [
    { id: "M", name: "Mesial" },
    { id: "O", name: "Occlusal" },
    { id: "I", name: "Incisal" },
    { id: "D", name: "Distal" },
    { id: "B", name: "Buccal" },
    { id: "V", name: "Ventral" },
    { id: "L", name: "Lingual" },
    { id: "MO", name: "Mesioclusal" },
    { id: "DO", name: "Distoclusal" },
    { id: "DI", name: "Distoincisal" },
    { id: "MOD", name: "Mesioclusodistal" },
  ];

  const subSites = [
    { id: "Right", name: "Right" },
    { id: "Left", name: "Left" },
    { id: "Upper", name: "Upper" },
    { id: "Down", name: "Down" },
    { id: "Anterior", name: "Anterior" },
    { id: "Posterior", name: "Posterior" },
    { id: "Interior", name: "Interior" },
    { id: "Exterior", name: "Exterior" },
  ];

  const medSelectionReasons = [
    { id: "Generic", name: "Generic" },
    { id: "patient-request", name: "patient-request" },
    { id: "innovative-noGeneric", name: "innovative-noGeneric" },
    { id: "physician-approval", name: "physician-approval" },
    { id: "physician-no-approval", name: "physician-no-approval" },
    { id: "drug-pharmacyUnavailable", name: "drug-pharmacyUnavailable" },
    { id: "drug-nationallyUnavailable", name: "drug-nationallyUnavailable" },
    { id: "Irreplaceable", name: "Irreplaceable" },
  ];

  const supportingInfoOptions = () => {
    let options = formikValues?.supportingInfos?.map((option, index) => ({
      ...option,
      name: option.category,
      id: index + 1,
      label: option.category,
      value: index + 1,
    }));

    return options;
  };

  const diagnosisOptions = () => {
    let options = formikValues?.diagnosisArr?.map((option, index) => ({
      ...option,
      name: option.codeDescription,
      id: index + 1,
      label: option.codeDescription,
      value: index + 1,
    }));

    return options;
  };

  const careTeamsOptions = () => {
    let options = formikValues?.careTeamsArr?.map((option, index) => ({
      ...option,
      name: option.practitionerName,
      id: index + 1,
      label: option.practitionerName,
      value: index + 1,
    }));

    return options;
  };

  const getInitialValues = (optionsArray, selectedIndexes) => {
    if (
      optionsArray?.length >= selectedIndexes?.length ||
      selectedIndexes.length > 0
    ) {
      const newSelectedIndexes = selectedIndexes.map((value) => value - 1);

      const selectedObjectsArray = _.at(optionsArray, newSelectedIndexes);
      return selectedObjectsArray;
    } else {
      return [];
    }
  };

  //formula net = ((quantity * unit price) * factor) + tax
  const addData = (itemData) => {
    let data = _.cloneDeep(itemData);

    // data["net"] = getNetValue(itemData);

    let tempFormData = [...formikValues.items];
    if (item) {
      tempFormData[currentItemIndex] = data;
    } else {
      tempFormData.push(data);
    }
    setMainFormFieldValue("items", tempFormData);
    resetForm();
    setCurrentItemIndex(setCurrentItemIndex);
    setShowAddItemModal(false);
  };

  // const getNetValue = (values) => {
  //   let quantity = parseFloat(values.quantity);
  //   let unit_price = parseFloat(values.unit_price);
  //   let tax_amount = parseFloat(values.tax_amount);
  //   let factor = parseFloat(values.factor);
  //   return quantity * unit_price * factor + tax_amount;
  // };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    resetForm,
    setFieldValue,
    isValid,
  } = useFormik({
    initialValues: {
      type: item?.type ? item?.type : "",
      standardCode: item?.standardCode ? item?.standardCode : "",
      standardCodeDescription: item?.standardCodeDescription
        ? item?.standardCodeDescription
        : "",
      non_standard_code: item?.non_standard_code
        ? item?.non_standard_code
        : null,
      non_standard_description: item?.non_standard_description
        ? item?.non_standard_description
        : null,
      body_site: item?.body_site ? item?.body_site : "",
      sub_site: item?.sub_site ? item?.sub_site : "",
      service_start_date: item?.service_start_date
        ? item?.service_start_date
        : currentDate.toISOString().substring(0, 10),
      service_end_date: item?.service_end_date ? item?.service_end_date : "",
      supporting_info: supportingInfoOptions().map((item) => item.id), // item?.supporting_info ? item?.supporting_info :
      diagnosis: diagnosisOptions().map((item) => item.id), // item?.diagnosis ? item?.diagnosis :
      care_teams: careTeamsOptions().map((item) => item.id), // item?.care_teams ? item?.care_teams :
      is_package: item?.is_package ? item?.is_package : false,
      quantity: item?.quantity ? item?.quantity : 1,
      unit_price: item?.unit_price ? item?.unit_price : 1,
      tax_amount: item?.tax_amount ? item?.tax_amount : 0,
      factor: item?.factor ? item?.factor : 1,
      net: item?.net ? item?.net : 1,
      invoice_no: item?.invoice_no ? item?.invoice_no : "",
      discount_amount: item?.discount_amount ? item?.discount_amount : 0,
      patient_share: item?.patient_share ? item?.patient_share : 0,
      patientShareAmount: item?.patientShareAmount
        ? item?.patientShareAmount
        : 0,
      payer_share: item?.payer_share ? item?.payer_share : 1,
      medicationSelectionReason: item?.medicationSelectionReason
        ? item?.medicationSelectionReason
        : "",
      prescribedMedication: item?.prescribedMedication
        ? item?.prescribedMedication
        : "",
      maternity: item?.maternity ? item?.maternity : false,
    },

    enableReinitialize: true,

    validationSchema: () => {
      return Yup.object().shape({
        type: Yup.string().required("Type is required"),
        // .test(
        //   "type-phar-required",
        //   "Type should be Medical Devices or Medication Codes in Pharmacy Type",
        //   function (value) {
        //     const { type } = this.parent;

        //     if (
        //       !(
        //         values.claimType === "pharmacy" &&
        //         (type === "medical-devices" || type === "medication-codes")
        //       )
        //     ) {
        //       return !!value;
        //     }
        //     return true;
        //   }
        // ),
        standardCode: Yup.string().required("Standard code is required"),
        standardCodeDescription: Yup.string().required(
          "Standard code description is required",
        ),
        // non_standard_code: Yup.number()
        //   .nullable()
        //   .required("Non-standard code is required"),
        // non_standard_description: Yup.string()
        //   .nullable()
        //   .required("Non-standard description is required"),
        // body_site: Yup.string().required("Body site is required"),
        // sub_site: Yup.string().required("Sub site is required"),
        // service_start_date: Yup.string().required("Service start date is required"),
        // service_end_date: Yup.string().required("Service end date is required"),
        // supporting_info: Yup.array().required("Supporting info is required"),
        // diagnosis: Yup.array().required("Diagnosis is required"),
        // care_teams: Yup.array().required("Care teams is required"),
        is_package: Yup.boolean().required("Is package is required"),
        quantity: Yup.string().required("Quantity is required"),
        unit_price: Yup.string().required("Unit price is required"),
        invoice_no: Yup.string().required("Invoice No is required"),
        // tax_amount: Yup.string().required("Tax amount is required"),
        // factor: Yup.string().required("Factor is required"),
        // net: Yup.string().required("Net is required"),
        discount_amount: Yup.string().required("Discount amount is required"),
        // patient_share: Yup.string().required("Patient share is required"),
        patientShareAmount: Yup.string().required(
          "Patient share amount is required",
        ),
        care_teams: Yup.array()
          .min(1, "Array must have at least one element")
          .nullable(),
        diagnosis: Yup.array()
          .min(1, "At least one diagonse required")
          .nullable(),
        // payer_share: Yup.string().required("Payer share is required"),
        medicationSelectionReason:
          values?.type === "medication-codes"
            ? Yup.string().required("Medication selection reason is required")
            : Yup.string(),

        prescribedMedication:
          values?.type === "medication-codes"
            ? Yup.string().required("Prescribed medication is required")
            : Yup.string(),
        maternity: Yup.boolean().required("Maternity is required"),
      });
    },
    onSubmit: (values, { setSubmitting }) => {
      addData(values);
    },
  });

  //yyy
  const handleDiscountAmountChange = (e) => {
    const discountAmount = parseFloat(e.target.value);
    setFieldValue("discount_amount", discountAmount);

    if (!isNaN(discountAmount) && values.quantity && values.unit_price) {
      const subTotal = values.quantity * values.unit_price;
      const newFactor = (subTotal - discountAmount) / subTotal;
      setFieldValue("factor", newFactor.toFixed(2));
      const netBeforeTax = subTotal - discountAmount;
      const taxAmount = parseFloat(values.tax_amount) || 0;
      const netWithTax = netBeforeTax + taxAmount;
      setFieldValue("net", netWithTax.toFixed(2));
    }
  };

  const handleFactorChange = (e) => {
    const factor = parseFloat(e.target.value);
    setFieldValue("factor", factor);

    if (!isNaN(factor) && values.quantity && values.unit_price) {
      const subTotal = values.quantity * values.unit_price;
      const newDiscountAmount = subTotal * (1 - factor);
      setFieldValue("discount_amount", newDiscountAmount.toFixed(2));
      const netBeforeTax = subTotal * factor;
      const taxAmount = parseFloat(values.tax_amount) || 0;
      const netWithTax = netBeforeTax + taxAmount;
      setFieldValue("net", netWithTax.toFixed(2));
    }
  };
  // useEffect(() => {
  //   if (values.quantity && values.unit_price) {
  //     const subTotal = values.quantity * values.unit_price;
  //     const discountAmount = subTotal * (1 - values.factor);
  //     setFieldValue("discount_amount", discountAmount.toFixed(2));
  //     setFieldValue("net", (subTotal - discountAmount).toFixed(2));
  //   }
  // }, [values.quantity, values.unit_price]);
  useEffect(() => {
    setFieldValue(
      "supporting_info",
      supportingInfoOptions().map((item) => item.id),
    );
  }, [formikValues?.supportingInfos]);
  useEffect(() => {
    setFieldValue(
      "diagnosis",
      diagnosisOptions().map((item) => item.id),
    );
  }, [formikValues?.diagnosisArr]);

  useEffect(() => {
    setFieldValue(
      "care_teams",
      careTeamsOptions().map((item) => item.id),
    );
  }, [formikValues?.careTeamsArr]);

  // useEffect(() => {
  //   if (values.quantity && values.unit_price && values.factor) {
  //     setFieldValue(
  //       "net",
  //       // (
  //       //   values.quantity * values.unit_price * values.factor +
  //       //   values.tax_amount
  //       // ).toFixed(2)
  //       (
  //         values.quantity *
  //         values.unit_price *
  //         (1 - values.discount_amount / (values.quantity * values.unit_price))
  //       ).toFixed(2)
  //     );
  //     // setFieldValue(
  //     //   "discount_amount",
  //     //   (
  //     //     values.unit_price -
  //     //     (
  //     //       values.quantity * values.unit_price * values.factor +
  //     //       values.tax_amount
  //     //     ).toFixed(2)
  //     //   ).toFixed(2)
  //     // );
  //   }
  // }, [values.unit_price, values.factor]);

  // yyy
  useEffect(() => {
    if (values.quantity && values.unit_price) {
      const subTotal = values.quantity * values.unit_price;
      const discountAmount = parseFloat(values.discount_amount) || 0;
      const netBeforeTax = subTotal - discountAmount;
      const taxAmount = parseFloat(values.tax_amount) || 0;
      const netWithTax = netBeforeTax + taxAmount;
      const newFactor = netBeforeTax / subTotal;

      setFieldValue("factor", newFactor.toFixed(2));
      setFieldValue("net", netWithTax.toFixed(2));
    }
  }, [
    values.quantity,
    values.unit_price,
    values.discount_amount,
    values.tax_amount,
  ]);

  // useEffect(() => {
  //   if (values.discount_amount && values.unit_price) {
  //     setFieldValue(
  //       "factor",
  //       (1 - values.discount_amount / values.unit_price).toFixed(2)
  //     );
  //   }
  // }, [values.discount_amount, values.unit_price]);

  const {
    loading: loadingSearchPriceListCode,
    error: errorSearchPriceListCode,
    data: dataSearchPriceListCode,
    refetch: refetchSearchPriceListCode,
  } = useQuery(priceList.SEARCH_PRICE_LIST_CODE, {
    variables: {
      input: "",
      payerId: formikValues?.payerId,
    },
    skip: true,
  });

  const handleSearch = (term) => {
    refetchSearchPriceListCode({
      input: term,
      payerId: formikValues?.payerId,
    }).then((data) => {
      setSearchResult(data?.data?.searchPriceListCode?.data || []);
    });
  };

  const debouncedSearch = _.debounce(handleSearch, 1000);

  const handleSearchChange = (event) => {
    const newSearchTerm = event.target.value;
    setSearchTerm(newSearchTerm);
    if (newSearchTerm.length >= 3) {
      debouncedSearch(newSearchTerm);
    } else {
      setSearchResult([]);
    }
  };

  // const handleSelectSearchItem = (item) => {
  //   setFieldValue("type", item?.service_type);
  //   setFieldValue("standardCode", item?.service_code);
  //   setFieldValue("standardCodeDescription", item?.service_desc);
  //   setFieldValue("non_standard_code", item?.non_standard_code);
  //   setFieldValue("non_standard_description", item?.non_standard_desc);
  //   setFieldValue("unit_price", item?.unit_price);
  //   setFieldValue("factor", item?.factor);

  //   setSearchResult([]);
  //   setSearchTerm("");
  // };

  // yyy
  const handleSelectSearchItem = (item) => {
    setFieldValue("type", item?.service_type);
    setFieldValue("standardCode", item?.service_code);
    setFieldValue("standardCodeDescription", item?.service_desc);
    setFieldValue("non_standard_code", item?.non_standard_code);
    setFieldValue("non_standard_description", item?.non_standard_desc);
    setFieldValue("unit_price", item?.unit_price);
    setFieldValue("factor", item?.factor);

    const quantity = values.quantity || 1;
    const unitPrice = item?.unit_price || 0;
    const factor = item?.factor || 1;
    const subTotal = quantity * unitPrice;
    const netBeforeTax = subTotal * factor;
    const taxAmount = values.tax_amount || 0;
    const netWithTax = netBeforeTax + parseFloat(taxAmount);
    const discountAmount = subTotal * (1 - factor);

    setFieldValue("quantity", quantity);
    setFieldValue("net", netWithTax.toFixed(2));
    setFieldValue("discount_amount", discountAmount.toFixed(2));

    if (item?.service_type === "medication-codes") {
      setFieldValue("prescribedMedication", item?.service_code);
      setFieldValue("medicationSelectionReason", "Generic");
    } else {
      setFieldValue("prescribedMedication", "");
      setFieldValue("medicationSelectionReason", "");
    }

    setSearchResult([]);
    setSearchTerm("");
  };

  useEffect(() => {
    if (values?.type === "medication-codes") {
      setFieldValue("medicationSelectionReason", "Generic");
    } else {
      setFieldValue("medicationSelectionReason", "");
      setFieldValue("prescribedMedication", "");
    }
  }, [values?.type]);

  return (
    <div
      className={`${showAddItemModal ? "open" : ""} modal add-item-modal`}
      id="search-filter"
    >
      <div class="modal-content !w-full">
        <div class="close">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            onClick={() => setShowAddItemModal(() => !showAddItemModal)}
          >
            <path
              d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
              fill="#DE5042"
            />
          </svg>
          <div class="bene-text !text-center mx-auto flex gap-2 justify-center">
            <div class="inventory-svg">
              <svg
                width="26"
                height="26"
                viewBox="0 0 34 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="34" height="34" rx="8" fill="#F4F6F8"></rect>
                <path
                  d="M9.25 11H11.25V14H21.25V11H23.25V16H25.25V11C25.25 9.9 24.35 9 23.25 9H19.07C18.65 7.84 17.55 7 16.25 7C14.95 7 13.85 7.84 13.43 9H9.25C8.15 9 7.25 9.9 7.25 11V25C7.25 26.1 8.15 27 9.25 27H15.25V25H9.25V11ZM16.25 9C16.8 9 17.25 9.45 17.25 10C17.25 10.55 16.8 11 16.25 11C15.7 11 15.25 10.55 15.25 10C15.25 9.45 15.7 9 16.25 9Z"
                  fill="#0070C2"
                ></path>
                <path
                  d="M25.25 17.5L19.76 23L16.75 20L15.25 21.5L19.76 26L26.75 19L25.25 17.5Z"
                  fill="#0070C2"
                ></path>
              </svg>
            </div>
            <span>Add Items</span>
          </div>
        </div>

        <div className="add_item_fields grid grid-cols-1 lg:grid-cols-2 mb-4">
          <div className="field flex flex-col gap-1 relative">
            <span className="absolute inset-y-0 left-0 pl-3 flex items-center">
              <BiSearch className="h-5 w-5 text-gray-400" />
            </span>
            <input
              type="text"
              placeholder="Search for item by Service Code or Service Description"
              onChange={handleSearchChange}
              value={searchTerm}
              className="block w-full py-2 !px-10 "
            />
            {searchTerm.length > 0 && (
              <span
                className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                onClick={() => {
                  setSearchResult([]);
                  setSearchTerm("");
                }}
              >
                <BiX className="h-7 w-7 text-gray-400" />
              </span>
            )}

            {/* {searchResult.length > 0 ? (
              <ul className="absolute top-full left-0 z-50 bg-white border border-gray-300 rounded-md mt-1 w-full max-h-72 overflow-y-auto">
                {searchResult.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => handleSelectSearchItem(item)}
                    className="py-1 px-3 cursor-pointer hover:bg-gray-100 border-b border-gray-300"
                  >
                    <div className="flex gap-3">
                      <div className="my-auto w-36 font-semibold capitalize ">
                        {item?.service_type}
                      </div>
                      <div className="pl-3 border-l border-gray-500">
                        <div className="border-b border-gray-200">
                          {item?.service_code}
                          {" | "}
                          {item?.service_desc}
                        </div>
                        <div>
                          {item?.non_standard_code}
                          {" | "}
                          {item?.non_standard_desc}
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              searchTerm.length > 3 && (
                <ul className="absolute top-full left-0 z-50 bg-white border border-gray-300 rounded-md mt-1 w-full max-h-72 overflow-y-auto">
                  <li className="py-1 px-3 cursor-pointer font-medium text-center text-lg">
                    No Result Found
                  </li>
                </ul>
              )
            )} */}

            {/* yyy */}
            {searchResult.length > 0 ? (
              <ul className="absolute top-full left-0 z-50 bg-white border border-gray-300 rounded-md mt-1 w-full max-h-72 overflow-y-auto">
                {searchResult.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => handleSelectSearchItem(item)}
                    className="py-1 px-3 cursor-pointer hover:bg-gray-100 border-b border-gray-300"
                  >
                    <div className="flex gap-3">
                      <div className="my-auto w-36 font-semibold capitalize ">
                        {item?.service_type}
                      </div>
                      <div className="pl-3 border-l border-gray-500">
                        <div className="border-b border-gray-200">
                          {item?.service_code} | {item?.service_desc}
                        </div>
                        <div>
                          {item?.non_standard_code} | {item?.non_standard_desc}
                        </div>
                        <div>
                          Unit Price: {item?.unit_price} | Factor:{" "}
                          {item?.factor}
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              searchTerm.length > 3 && (
                <ul className="absolute top-full left-0 z-50 bg-white border border-gray-300 rounded-md mt-1 w-full max-h-72 overflow-y-auto">
                  <li className="py-1 px-3 cursor-pointer font-medium text-center text-lg">
                    No Result Found
                  </li>
                </ul>
              )
            )}
          </div>
        </div>

        <div className="add_item_fields grid grid-cols-1 lg:grid-cols-5 gap-3">
          <CustomFilterInput
            label="Select Type*"
            name="type"
            isSelect={true}
            placeholder="Select Type*"
            options={types}
            value={values.type}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.type}
            touched={touched.type}
          />
          <div className="field flex flex-col gap-1">
            <label
              htmlFor="Select-Type"
              className="text-[12px] font-medium text-gray-700"
            >
              Search for Code {" ("}
              {values.standardCode ? values.standardCode : ""}
              {")"}
            </label>

            <ItemCodesSearchNSelect
              typeName={values.type}
              setFieldValue={(val) => {
                setFieldValue(`standardCode`, val.code);
                setFieldValue(`standardCodeDescription`, val.description);
                if (values?.type === "medication-codes") {
                  setFieldValue(`prescribedMedication`, val?.code);
                } else {
                  setFieldValue(`prescribedMedication`, "");
                }
              }}
            />
            {errors.standardCode && touched.standardCode ? (
              <p className="max-w-2xl text-sm leading-6 text-red-500">
                {errors.standardCode}
              </p>
            ) : null}
            {errors.standardCodeDescription &&
            touched.standardCodeDescription ? (
              <p className="max-w-2xl text-sm leading-6 text-red-500">
                {errors.standardCodeDescription}
              </p>
            ) : null}
          </div>

          <CustomFilterInput
            label="Non Standard Code"
            name="non_standard_code"
            placeholder="Non Standard Code"
            value={values.non_standard_code ?? ""}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <CustomFilterInput
            label="Non Standard Description"
            name="non_standard_description"
            placeholder="Non Standard Description"
            value={values.non_standard_description ?? ""}
            onChange={handleChange}
            onBlur={handleBlur}
          />

          <div className="field flex flex-col gap-1">
            <div className="flex gap-2">
              <div className="flex-1">
                <CustomFilterInput
                  label="Body Site"
                  name="body_site"
                  isSelect={true}
                  placeholder="Body Site"
                  options={
                    values.type == "oral-health-op" ||
                    formikValues.claimType === "oral"
                      ? oralItems
                      : sites
                  }
                  value={values.body_site}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={
                    values.type == "oral-health-op" ||
                    formikValues.claimType === "oral"
                      ? "!rounded-r-none"
                      : ""
                  }
                />
              </div>
              {values.type == "oral-health-op" ||
              formikValues.claimType === "oral" ? (
                <Button
                  autoFocus
                  size="small"
                  onClick={() => {
                    setShowTeethSelectModal(true);
                    setShowAddItemModal(false);
                  }}
                  variant="contained"
                  style={{
                    backgroundImage: "linear-gradient(83deg, #0070C2)",
                  }}
                  className="!rounded-l-none !rounded-r-md !self-end"
                >
                  {"Select"}
                </Button>
              ) : null}
            </div>
          </div>
          <CustomFilterInput
            label="Sub Site"
            name="sub_site"
            isSelect={true}
            placeholder="Sub Site"
            options={
              values.type == "oral-health-op"
                ? dentalSubSites.map((item) => ({
                    id: item.name,
                    name: item.name,
                  }))
                : subSites.map((item) => ({ id: item.name, name: item.name }))
            }
            value={values.sub_site}
            onChange={handleChange}
            onBlur={handleBlur}
          />

          <CustomFilterInput
            label="Service Start Date"
            name="service_start_date"
            type="date"
            value={values.service_start_date}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <CustomFilterInput
            label="Service End Date"
            name="service_end_date"
            type="date"
            value={values.service_end_date}
            onChange={handleChange}
            onBlur={handleBlur}
          />

          <div className="flex flex-col gap-1">
            <label
              htmlFor="service_end_date"
              className="text-[12px] font-medium text-gray-700"
            >
              Supporting Info
            </label>

            <MultiSelectComponent
              multiValues={supportingInfoOptions()}
              setSelectedValue={(val) => {
                let temp = val.map((item) => item.id);
                setFieldValue("supporting_info", [...temp]);
              }}
              initialSelectedValues={getInitialValues(
                supportingInfoOptions(),
                values.supporting_info,
              )}
            />
          </div>
          <div className="flex flex-col gap-1">
            <label
              htmlFor="service_end_date"
              className="text-[12px] font-medium text-gray-700"
            >
              Diagnosis
            </label>

            <MultiSelectComponent
              multiValues={diagnosisOptions()}
              setSelectedValue={(val) => {
                let temp = val.map((item) => item.id);
                setFieldValue("diagnosis", [...temp]);
              }}
              initialSelectedValues={getInitialValues(
                diagnosisOptions(),
                values.diagnosis,
              )}
            />
            {errors.diagnosis && touched.diagnosis ? (
              <p className="max-w-2xl text-sm leading-6 text-red-500">
                {errors.diagnosis}
              </p>
            ) : null}
          </div>
          <div className="flex flex-col gap-1">
            <label
              htmlFor="service_end_date"
              className="text-[12px] font-medium text-gray-700"
            >
              Care Teams
            </label>

            <MultiSelectComponent
              multiValues={careTeamsOptions()}
              setSelectedValue={(val) => {
                let temp = val.map((item) => item.id);
                setFieldValue("care_teams", [...temp]);
              }}
              initialSelectedValues={getInitialValues(
                careTeamsOptions(),
                values.care_teams,
              )}
            />
            {errors.care_teams && touched.care_teams ? (
              <p className="max-w-2xl text-sm leading-6 text-red-500">
                {errors.care_teams}
              </p>
            ) : null}
          </div>
          <CustomFilterInput
            label="Is Package? *"
            name="is_package"
            isSelect={true}
            placeholder="Is Package? *"
            options={[
              { id: "true", name: "Yes" },
              { id: "false", name: "No" },
            ]}
            value={
              values.is_package === true
                ? "true"
                : values.is_package === false
                  ? "false"
                  : ""
            }
            onChange={(e) =>
              setFieldValue(
                "is_package",
                e.target.value === "true"
                  ? true
                  : e.target.value === "false"
                    ? false
                    : "",
              )
            }
            onBlur={handleBlur}
            error={errors.is_package}
            touched={touched.is_package}
          />

          <CustomFilterInput
            label="Is Maternity*"
            name="maternity"
            isSelect={true}
            placeholder="Is Maternity*"
            options={[
              { id: "true", name: "Yes" },
              { id: "false", name: "No" },
            ]}
            value={
              values.maternity === true
                ? "true"
                : values.maternity === false
                  ? "false"
                  : ""
            }
            onChange={(e) =>
              setFieldValue(
                "maternity",
                e.target.value === "true"
                  ? true
                  : e.target.value === "false"
                    ? false
                    : "",
              )
            }
            onBlur={handleBlur}
            error={errors.maternity}
            touched={touched.maternity}
          />

          {values.type == "medication-codes" && (
            <>
              <CustomFilterInput
                label="Medication Selection Reason *"
                name="medicationSelectionReason"
                isSelect={true}
                placeholder="Please Select"
                options={medSelectionReasons}
                value={values.medicationSelectionReason}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.medicationSelectionReason}
                touched={touched.medicationSelectionReason}
              />
              <div className="field flex flex-col gap-1">
                <label
                  htmlFor="prescribedMedication"
                  className="block text-[11px] font-medium text-gray-700"
                >
                  Prescribed Medication{" ("}
                  {values.prescribedMedication
                    ? values.prescribedMedication
                    : ""}
                  {")"} <span className="text-sm text-red-500"> *</span>
                </label>

                <ItemCodesSearchNSelect
                  typeName={values.type}
                  setFieldValue={(val) => {
                    setFieldValue(`prescribedMedication`, val.code);
                  }}
                />
                {errors.prescribedMedication && touched.prescribedMedication ? (
                  <p className="max-w-2xl text-sm leading-6 text-red-500">
                    {errors.prescribedMedication}
                  </p>
                ) : null}
              </div>
            </>
          )}
        </div>

        <Divider className="my-4" />

        <div className="add_item_fields grid grid-cols-1 lg:grid-cols-5 gap-3">
          <CustomFilterInput
            label="Invoice No*"
            name="invoice_no"
            placeholder="Invoice No."
            value={values.invoice_no}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.invoice_no}
            touched={touched.invoice_no}
          />

          <CustomFilterInput
            label="Enter Quantity"
            name="quantity"
            type="number"
            placeholder="Enter Quantity"
            value={values.quantity}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.quantity}
            touched={touched.quantity}
          />
          <CustomFilterInput
            label="Enter Unit Price"
            name="unit_price"
            type="number"
            placeholder="Enter Unit Price"
            value={values.unit_price}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.unit_price}
            touched={touched.unit_price}
          />

          <CustomFilterInput
            label="Discount Amount *"
            name="discount_amount"
            type="number"
            placeholder="Discount Amount *"
            value={values.discount_amount}
            onChange={handleDiscountAmountChange}
            onBlur={handleBlur}
            error={errors.discount_amount}
            touched={touched.discount_amount}
          />

          <CustomFilterInput
            label="Patient Share (%)"
            name="patient_share"
            type="number"
            placeholder="Patient Share (%)"
            value={values.patient_share}
            onChange={handleChange}
            onBlur={handleBlur}
          />

          <CustomFilterInput
            label="Tax Amount"
            name="tax_amount"
            type="number"
            placeholder="Tax Amount"
            value={values.tax_amount}
            min={0}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <CustomFilterInput
            label="Factor"
            name="factor"
            type="number"
            placeholder="Factor"
            value={values.factor}
            onChange={handleFactorChange}
            onBlur={handleBlur}
          />

          <CustomFilterInput
            label="Net *"
            name="net"
            type="number"
            placeholder="Net *"
            value={values.net}
            onChange={handleChange}
            onBlur={handleBlur}
          />

          <CustomFilterInput
            label="Patient Share Amount *"
            name="patientShareAmount"
            type="number"
            placeholder="Patient Share Amount *"
            value={values.patientShareAmount}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.patientShareAmount}
            touched={touched.patientShareAmount}
          />
          <CustomFilterInput
            label="Payer Share"
            name="payer_share"
            placeholder="Payer Share"
            value={values.payer_share}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </div>

        <div class="request-eligible-btns mt-8 justify-center gap-3">
          <AppButton
            label="Cancel"
            variant="outlined"
            bgColor="#6B7280"
            onClick={() => {
              resetForm();
              setShowAddItemModal(false);
            }}
          />
          <AppButton
            label={item ? "Update" : "Save"}
            bgColor="#0070C2 !important"
            onClick={handleSubmit}
            disabled={!isValid}
          />
        </div>
      </div>
      <DentalTeethSelectModalItem
        setShowAddItemModal={setShowAddItemModal}
        setShowTeethSelectModal={setShowTeethSelectModal}
        showTeethSelectModal={showTeethSelectModal}
        setFieldValue={setFieldValue}
      />
    </div>
  );
}

export default AddItemModal;

// {/* LOGS Formulas */}
// {console.log("Quantity: ", values.quantity)}
// {console.log("Unit Price: ", values.unit_price)}
// {console.log("Discount Amount: ", values.discount_amount)}
// {console.log("SUb Total: ", values.quantity * values.unit_price)}
// {console.log(
//   "Discount Percentage: ",
//   values.discount_amount / (values.quantity * values.unit_price)
// )}
// {console.log(
//   "Factor: ",
//   1 - values.discount_amount / (values.quantity * values.unit_price)
// )}
// {console.log(
//   "Net: ",
//   values.quantity *
//     values.unit_price *
//     (1 -
//       values.discount_amount / (values.quantity * values.unit_price))
// )}

// {console.log("DIScount Percentage: ", (1 - (1 - (values.discount_amount / (values.quantity * values.unit_price)))))}
// {console.log("Discount Amount: ", 1 - (1 - (values.discount_amount / (values.quantity * values.unit_price))) * (values.quantity * values.unit_price))}
